'use strict';

var compact = require('mdast-util-compact');

module.exports = compile;

/* Stringify the given tree. */
function compile() {
  return this.visit(compact(this.tree, this.options.commonmark));
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/macro/compile.js
// module id = 276
// module chunks = 147254134005266 182246549230831 215303740077764